
import React, {useContext, useEffect, useState } from 'react'
import axios from 'axios';
import PaysContext from "../contexts/payscontext";
import { use } from 'react';
import { FaSearch } from 'react-icons/fa';
import Editregionform from './Editregionform';
import Pdfpaysbulletin from './Pdfpaysbulletin';


export default function PutFormulaire(props) {
    const payscourant = useContext(PaysContext)  
    const [lstregioninfo, SetLstregioninfo] = useState([])
    const[query, SetQuery] = useState("")
    const[btnEdit, SetBtnEdit] = useState(false);
    const [coderegion, SetCoderegion] = useState("")


    
    // chargement les données du pays à modifier
    //const chaineparam = {payscourant}       
   const urlgetregioninfo = `http://localhost:8000/eagrimetApi/regionInfo/?pays=${payscourant}`   
   const  axiosconfig = {
        headers: {
        "Content-Type": "application/json",
        Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
        }
     };

     function regmodifier(id){
        console.log(id)
        SetCoderegion(id)
        console.log(id.region)
       
     }

    function gotoListRegionInfo(){
      SetBtnEdit(false)
     }

     

     useEffect( () => {
        const cherchregioninfo = async() =>{
            await axios.get(urlgetregioninfo, axiosconfig)           
           .then((resultat) => {
                SetLstregioninfo(resultat.data);
                console.log("resultat trouvé");
             }
            ) 
           .catch((err) => console.log(err));  
        };
        cherchregioninfo()
     }, [payscourant, query])

    //if(props.adminExiste && props.modemodif  && !btnEdit)
    if(props.adminExiste && props.modemodif  ){
       if (btnEdit === false){
        return ( 
            //props.adminExiste && props.modemodif &&  
            
            <div className="container p-2">  
                <form>
                <Pdfpaysbulletin payscourant={payscourant}/>
                <h1>Mise à jour {payscourant}</h1>

                <div className='mx-5 col-2  '>
                    <FaSearch id="search-icon"/>
                    <input placeholder='region to search ..' onChange={(e) => {SetQuery(e.target.value); } }/>
                </div>
                <table className="table">
                <thead>
                    <tr>
                    <th scope="col">Localite</th>
                    <th scope="col">Langue</th>
                    <th scope="col">Source</th>
                    <th hidden scope="col">Bulletin</th>
                    <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    
                        
                    {lstregioninfo.filter((rinfo) => rinfo.region.toLowerCase().includes(query) || rinfo.region.toUpperCase().includes(query)).map((rinfo) => {                        
                        return ( 
                            <tr key={rinfo.code}>                    
                            <td > {rinfo.region} </td>
                            <td > {rinfo.langue} </td>
                            <td > {rinfo.sourceinfo}  </td>                              
                            <td hidden> <a href={rinfo.bulletinPdf} target="_blank">PDF</a> </td> 
                            <td > <button className='btn btn-success' type='button' onClick={() => { regmodifier(rinfo.code) ; SetBtnEdit(true) }  }>Modifier</button></td>                  
                            </tr>
                        )
                    })}
                   
                </tbody>
        
                </table>
                
                </form>
                
        
            </div>
          )// fin return
          }
          else{
            //mode Edition
            return (
              <div className=" container p-2"> 
                 <div className='row col-2'>
                      <button className='btn' onClick={gotoListRegionInfo}><i className="bi bi-arrow-return-left"></i> Back</button>
                  </div> 
                  <div className='d-flex justify-content-center'>
                     <Editregionform coderegion = {coderegion}/>   
                     
                </div>
              </div>
            )
            
          }
        }

    
     //if(props.adminExiste && props.modemodif && btnEdit ) {  
    //if(btnEdit ){
        
       
    //}


  /*return ( 
    props.adminExiste && props.modemodif &&  
    
    <div>
        <form>
        <h1>Mise à jour {payscourant}</h1>
        <div className='mx-5 col-2  '>
            <FaSearch id="search-icon"/>
            <input placeholder='region to search ..' onChange={(e) => SetQuery(e.target.value)}/>
        </div>
        <table className="table">
        <thead>
            <tr>
            <th scope="col">Region</th>
            <th scope="col">Langue</th>
            <th scope="col">Source</th>
            <th scope="col">AlertMessage</th>
            <th scope="col">Action</th>
            </tr>
        </thead>
        <tbody>
            
                
            {lstregioninfo.filter((rinfo) => rinfo.region.toLowerCase().includes(query)).map((rinfo) => {                        
                return ( 
                    <tr key={rinfo.code}>                    
                    <td > {rinfo.region} </td>
                    <td > {rinfo.langue} </td>
                    <td >   {rinfo.sourceinfo}  </td>
                    <td > {rinfo.alertMessage} </td>   
                    <td > <button className='btn btn-success' type='button' onClick={() => regmodifier(rinfo.code)}>Modifier</button></td>                  
                    </tr>
                )
            })}
           
        </tbody>

        </table>
        
        </form>
        

    </div>
  ) */
}
